export default __webpack_public_path__ + "static/favicon-140a5ab13e33573830462e598e95a24f.png";